import axiosClient from "utils/api/axios-client";

export default {
  getAll: (params) => {
    const url = "/api/v1/express/combo-transactions";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/express/combo-transactions/${id}`;
    return axiosClient.get(url);
  },
};
